import { render, staticRenderFns } from "./bundle-card-fees.vue?vue&type=template&id=41fb6878"
import script from "./bundle-card-fees.vue?vue&type=script&lang=ts"
export * from "./bundle-card-fees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports